import { createContext, useReducer } from 'react'
import startupReducer from './StartupReducer'

const StartupContext = createContext()

export const StartupProvider = ({ children }) => {
  const initialState = {
    startups: [],
    startup: {},
    categories: [],
    phaseOperations: [],
    provinces: [],
    cities: [],
    ticket: {},
    file: '',
    rounds: [],
    round: {},
    admins: [],
    loading: false,
    projectIds: []
  }

  const [state, dispatch] = useReducer(startupReducer, initialState)

  return (
    <StartupContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </StartupContext.Provider>
  )
}

export default StartupContext
